import Card from 'components/Badge';
import styled from 'styled-components';

export const MapsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 10px;
  padding-top: 1rem;

  .leaflet-top.leaflet-left {
    top: 46px;
  }
`;

export const StyledClusterMarker = styled.div`
  color: #fff;
  background: #1978c8;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardStyled = styled(Card)`
  position: absolute;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1) !important;
  background: white;
  opacity: 91%;
  z-index: 1000;
  border-radius: 10px !important;
  margin-top: -12rem;
  width: inherit;
  max-height: 150px;
  overflow: scroll;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.light_gray};
    opacity: 0.5;
  }
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
  }
  @media (max-width: 425px) {
    font-size: 1px !important;
    margin-top: 2% !important;
  }

  @media (max-width: 1440px) {
    font-size: 1px;
  }
`;

export const CloseDetailButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  padding: 0;

  &:hover,
  &:focus {
    background: ${(props) => props.theme.colors.light_gray};
    outline: none;
  }
`;

export const FullscreenButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1001;
  width: 36px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  color: #5f6368;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover,
  &:focus {
    background: #f8f9fa;
    outline: none;
  }
`;
